import { render, staticRenderFns } from "./WsExamLog.vue?vue&type=template&id=00d87f15"
import script from "./WsExamLog.vue?vue&type=script&lang=js"
export * from "./WsExamLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports